import { createAuthClient } from "better-auth/react";
import { organizationClient } from "better-auth/client/plugins";

// Same-origin in dev (Vite proxies /api → Express on :3004) and in prod
// (single host serving UI + API). If we ever split origins, set
// VITE_API_BASE_URL and add CORS to Express.
export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? window.location.origin,
  basePath: "/api/auth",
  plugins: [organizationClient()],
});

export const { useSession, signIn, signUp, signOut, organization } = authClient;
